import { useEffect, useState } from 'react'
import { CornerDownLeft, MessageSquareText, Sparkles } from 'lucide-react'

import { CommandDialog, CommandGroup, CommandInput, CommandItem, CommandList } from 'components/ui/command'

import { useAskMdt } from '../context/AskMdtProvider'
import { useRouteAssetContext } from '../hooks/useRouteAssetContext'
import { suggestionsFor } from '../suggestions'

/**
 * The Cmd/Ctrl+K prompt (MYD-621): type a question, or pick a suggestion for
 * this screen. Enter sends it and opens the conversation panel.
 *
 * cmdk is a picker, so Enter selects the highlighted item. What the user typed
 * is therefore always the FIRST item ("Ask: …"), highlighted by default, and
 * filtering is off: suggestions are offered, not searched.
 */
export function AskMdtCommandDialog() {
	const askMdt = useAskMdt()
	const routeContext = useRouteAssetContext()
	const [text, setText] = useState('')
	const open = askMdt?.mode === 'palette'

	// A fresh prompt every time it opens.
	useEffect(() => {
		if (open) setText('')
	}, [open])

	if (!askMdt) return null
	const typed = text.trim()

	return (
		<CommandDialog open={open} onClose={askMdt.close} label="Ask MDT" shouldFilter={false}>
			<CommandInput value={text} onValueChange={setText} placeholder="Ask about your locations, projects, evaluations…" aria-label="Ask MDT" />
			<CommandList className="max-h-[360px]">
				{typed && (
					<CommandGroup>
						<CommandItem value={`ask:${typed}`} onSelect={() => askMdt.ask(typed)} className="gap-2">
							<Sparkles className="h-4 w-4 shrink-0 text-primary" />
							<span className="min-w-0 flex-1 truncate">Ask: {typed}</span>
							<CornerDownLeft className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
						</CommandItem>
					</CommandGroup>
				)}
				<CommandGroup heading="Try asking">
					{suggestionsFor(routeContext).map(prompt => (
						<CommandItem key={prompt} value={`suggest:${prompt}`} onSelect={() => askMdt.ask(prompt)} className="gap-2">
							<MessageSquareText className="h-4 w-4 shrink-0 text-muted-foreground" />
							<span className="min-w-0 flex-1 truncate">{prompt}</span>
						</CommandItem>
					))}
				</CommandGroup>
				<CommandGroup heading="Conversation">
					<CommandItem value="open-panel" onSelect={askMdt.openPanel} className="gap-2">
						<MessageSquareText className="h-4 w-4 shrink-0 text-muted-foreground" />
						<span>Open the conversation</span>
					</CommandItem>
				</CommandGroup>
			</CommandList>
		</CommandDialog>
	)
}

export default AskMdtCommandDialog
